import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';

export const useRateExcludingProductsMutation = () => {
    return useRepositoryMutation('reservations', 'setDefaultProductOrderAmount', {
        onSuccess: () => showSuccessAlert({ description: lt('ReservationRepriceSuccessMessage') }),
    });
};
